<template>
  <div class="login flex items-center h-screen w-full bg-white">
    <div
      class="w-full bg-white rounded-lg shadow-lg flex flex-col justify-items-center p-8 m-4 md:max-w-sm md:mx-auto"
    >
    <div class="flex justify-center w-full">
      <img src="@/assets/logo-plataforma_web_400.png" class="logo"/>

    </div>
      <div class="flex flex-wrap -mx-3 pt-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="w-full flex justify-center items-center text-gray-900"
              >
                <span class="text-xs legend font-bold">Plataforma del Colectivo de Investigación e Incidencia "Tejedores del Territorio".
                </span>
              </label>
            </div>
          </div>
      <div class="flex flex-col w-full mt-6">
        <form
          class="w-full max-w-lg"
          id="signInForm"
          @submit.prevent="loginSubmit"
        >
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
                id="email"
                type="text"
                name="email"
                v-model="email"
                placeholder="Ingrese su correo electrónico"
              />
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <input
                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-teal-500"
                id="password"
                type="password"
                name="password"
                v-model="password"
                placeholder="Ingreso su contraseña"
              />
            </div>
          </div>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full px-3 mb-6 md:mb-0">
              <label
                class="w-full flex justify-center items-center text-gray-900"
              >
                <input
                  class="mr-2 leading-tight"
                  type="checkbox"
                  v-model="isSavedLogin"
                />
                <span class="text-sm"> Mantener la sesión iniciada </span>
              </label>
            </div>
          </div>
          <div class="flex w-full justify-center pt-2">
            <button
              class="bg-secondary-color hover:bg-secondary-color-dark px-4 py-2 text-center rounded-lg text-gray-100 tracking-wider uppercase font-bold"
              type="submit"
            >
              Iniciar sesión
            </button>
          </div>
          <div class="flex w-full justify-center pt-6">
            <a
              v-on:click="openResetPasswordModal()"
              class="cursor-pointer hover:text-gray-600 tracking-wider"
              >¿Olvidaste tu contraseña?</a
            >
          </div>
          <div class="flex w-full justify-center pt-2">
            <a
              v-on:click="goToRegister()"
              class="cursor-pointer hover:text-gray-600 tracking-wider"
              >Crear una nueva cuenta</a
            >
          </div>
        </form>
      </div>
    </div>
    <reset-password-modal
      :showing="showResetPasswordModal"
      @close="showResetPasswordModal = false"
    ></reset-password-modal>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errorMessage }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<style scoped>
.login {
  background-color: #81916C;
  
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import ResetPassword from "./ResetPassword";
import AlertDialog from "./AlertDialog";

export default {
  data() {
    return {
      email: "",
      password: "",
      isSavedLogin: false,
      showResetPasswordModal: false,
      showingError: false,
      errorMessage: "",
    };
  },
  components: {
    "reset-password-modal": ResetPassword,
    AlertDialog,
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "accessToken"]),
  },
  methods: {
    ...mapActions(["doLogin"]),
    loginSubmit() {
      this.doLogin({
        email: this.email,
        password: this.password,
        isSavedLogin: this.isSavedLogin,
        type: "monitor",
      }).catch((error) => {
        this.errorMessage = error;
        this.showingError = true;
      });
    },
    openResetPasswordModal() {
      this.showResetPasswordModal = true;
    },
    goToRegister() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.legend{
 font-weight: bold;
 font-style:italic;

}
.logo{
  max-width: 90%;
}
</style>
